import { DpOutlinedInput } from '@/components/blocks/OutlinedInput';
import { useLocalization } from '@/data/Localization';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, SxProps, Theme } from '@mui/material';
import { FC, useId, useState } from 'react';
type Props = {
	label: string;
	name: string;
	value?: string;
	disabled?: boolean;
	placeholder?: string;
	inputProps?: object;
	required?: boolean;
	sx?: SxProps<Theme>;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
	onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	error?: boolean;
	autoFocus?: boolean;
	helperText?: string;
	fullWidth?: boolean;
};

export const PasswordInput: FC<Props> = ({
	label,
	name,
	value,
	disabled,
	placeholder,
	inputProps,
	required,
	sx,
	onChange,
	onBlur,
	onFocus,
	onClick,
	onKeyDown,
	error = false,
	autoFocus = false,
	helperText = '',
	fullWidth = true,
}) => {
	const id = useId();
	const [showPassword, setShowPassword] = useState<boolean>(true);
	const passwordInputNLS = useLocalization('PasswordInput');

	const handleShowPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setShowPassword((prev) => !prev);
	};

	return (
		<DpOutlinedInput
			id={`${id}-adorned-password`}
			data-testid={`${id}-adorned-password`}
			name={name}
			type={showPassword ? 'password' : 'text'}
			fullWidth={fullWidth}
			autoComplete="off"
			value={value}
			autoFocus={autoFocus}
			onChange={onChange}
			onBlur={onBlur}
			onFocus={onFocus}
			onClick={onClick}
			onKeyDown={onKeyDown}
			inputProps={inputProps}
			label={label}
			error={error}
			disabled={disabled}
			placeholder={placeholder}
			required={required}
			helperText={helperText}
			sx={sx}
			InputLabelProps={{
				sx: { fontSize: 'var(--font-size-body)', lineHeight: '1' },
			}}
			FormHelperTextProps={{
				sx: { ml: '3px' },
			}}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton
							sx={{
								':hover': { backgroundColor: 'transparent' },
								':active': { backgroundColor: 'transparent' },
							}}
							aria-label={passwordInputNLS.toggleLabel.t()}
							onClick={handleShowPassword}
							onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => {
								event.preventDefault();
							}}
							edge="end"
							disableRipple
						>
							{showPassword ? (
								<VisibilityOff htmlColor="#C9C9C9" />
							) : (
								<Visibility htmlColor="#C9C9C9" />
							)}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};
